import React, { createContext, useContext, useState } from 'react'

interface AbcProductsContextData {
  setFilters: React.Dispatch<React.SetStateAction<any>>
  filters: any
}

export const AbcProductsContext = createContext<AbcProductsContextData>(
  {} as AbcProductsContextData
)

export const AbcProductsProvider: React.FC = ({ children }) => {
  const [filters, setFilters] = useState<any>({})

  return (
    <AbcProductsContext.Provider
      value={{
        setFilters,
        filters
      }}
    >
      {children}
    </AbcProductsContext.Provider>
  )
}

export function useAbcProductsContext() {
  return useContext(AbcProductsContext)
}
